module.exports = __webpack_public_path__ + "img/loan-dollar.325a405c.png";